module.exports = __webpack_public_path__ + "images/aa574108f2cceb126ae346d3dcf728d4.svg";